import { Ability } from "~auth/Ability.ts";
import { usePermitted } from "~auth/usePermitted.ts";
import { useCurrentEmployee } from "~contexts/CurrentEmployeeContext/CurrentEmployeeContext.tsx";
import { useManagerAccountPhotos } from "../../api/photoDocumentationView.ts";

export function usePhotoDocAssignmentTaskBar({
  enabled = true,
}: {
  enabled?: boolean;
} = {}): {
  hasTasks: boolean;
  pendingCount: number;
} {
  const isPermitted = usePermitted();
  const { currentEmployee } = useCurrentEmployee();
  const shouldQuery =
    enabled && isPermitted([Ability.canAssignPhotoDocumentation]);

  const { data } = useManagerAccountPhotos(
    shouldQuery ? currentEmployee.id : undefined,
    { enabled: shouldQuery },
  );

  const pendingCount = shouldQuery ? (data?.length ?? 0) : 0;

  return { hasTasks: pendingCount > 0, pendingCount };
}
